import { API_URL } from "./api";

export interface ValuationSamplePayload {
  marque: string;
  modele: string;
  annee: string;
  kilometrage: string;
  energie: string;
  boite: string;
  finition: string;
  prix: string;
  source_url: string;
  pays: string;
  date_releve: string;
  admin_validated: boolean;
  door_count?: number | string;
  seat_count?: number | string;
}

export interface ValuationSample {
  id: number;
  marque?: string;
  modele?: string;
  annee?: string;
  kilometrage?: number;
  energie?: string;
  boite?: string;
  finition?: string;
  prix?: number;
  source_url?: string;
  pays?: string;
  date_releve?: string;
  admin_validated?: boolean;
  created_at?: string;
  created_by?: string;
  door_count?: number;
  seat_count?: number;
}

export async function fetchSamples(): Promise<ValuationSample[]> {
  const res = await fetch(`${API_URL}/valuation/samples`, { credentials: "include" });
  if (!res.ok) throw new Error("Erreur chargement échantillons");
  return (await res.json()) as ValuationSample[];
}

export async function createSample(payload: ValuationSamplePayload) {
  const res = await fetch(`${API_URL}/valuation/samples`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("Erreur création échantillon");
  return res.json();
}

export async function updateSample(id: number, payload: Partial<ValuationSamplePayload>) {
  const res = await fetch(`${API_URL}/valuation/samples/${id}`, {
    method: "PATCH",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("Erreur mise à jour échantillon");
  return res.json();
}

export async function deleteSample(id: number) {
  const res = await fetch(`${API_URL}/valuation/samples/${id}`, {
    method: "DELETE",
    credentials: "include",
  });
  if (!res.ok) throw new Error("Erreur suppression échantillon");
}

export async function uploadSamplesCsv(file: File) {
  const form = new FormData();
  form.append("file", file);
  const res = await fetch(`${API_URL}/valuation/samples/upload`, {
    method: "POST",
    credentials: "include",
    body: form,
  });
  if (!res.ok) throw new Error("Erreur import CSV");
  return res.json();
}
